import { type BoundActions, createHook, type HookFunction } from 'react-sweet-state';

import { type AgentModalStoreActions } from './AgentModalStoreActions';
import { type AgentModalStoreState, store } from './store';

export const useAgentsModal: HookFunction<
	AgentModalStoreState,
	BoundActions<AgentModalStoreState, AgentModalStoreActions>,
	void
> = createHook(store);
